/* eslint-disable */
import { useState } from "react";
import UploadFiles from "components/modals/UploadShift";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Text from "components/general/Text";
import Button from "components/general/Button";
import Image from "components/general/Image";
import ImportImage from "assets/icons/import.svg";
import DownloadImage from "assets/icons/download.svg";
import { ShiftType, ShiftTypeName } from "constants/ShiftType";
import AssignShift from "components/modals/AssignShift";
import useGetUserInfo from "hooks/useGetUserInfo";
import styles from "./styles.module.scss";
import { useLazyExportStaffShiftQuery } from "apis/services/other";
import HandleErrors from "utils/handleErrors";
import { Spin, Tooltip } from "antd";
import usePermissions from "hooks/usePermission";
import SYNC_ICON from "assets/icons/sync.svg";
import Recalculate from "components/modals/Recalculate";

export default function TabHeader({
  containerStyle,
  shifType,
  title,
  showBtns = true,
  showRefreshBtn = false,
}: any) {
  const [isDetailsShown, setIsDetailsShown] = useState(false);
  const [isAssignShown, setIsAssingShown] = useState(false);
  const [isRecalculateShown, setIsRecalculateShown] = useState(false);
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const [exportShift] = useLazyExportStaffShiftQuery();
  const [isExporting, setisExporting] = useState(false);
  const { hasPermissionTo } = usePermissions()

  const hasBulkUploadPermission = hasPermissionTo("view_export")
  const canRecalculate = hasPermissionTo("recalculate_shifts")
  const assignPermissions = {
    "Fixed Shift": hasPermissionTo("assign_fixed_shift"),
    "Flexible Shift": hasPermissionTo("assign_flexible_shift"),
    "Based Setup Shift": hasPermissionTo("assign_based_shift"),
  }

  const shiftTypePermission = assignPermissions[ShiftTypeName[shifType] as keyof typeof assignPermissions]

  const handleDownloadTemplate = () => {
    setisExporting(true);
    exportShift({
      shift_type: shifType,
      start_date:
        searchParams.get("startDate") ??
        moment(new Date()).format("YYYY-MM-DD"),
      end_date: searchParams.get("endDate") ?? undefined,
      time: new Date().getTime(),
    })
      .unwrap()
      .then((res) => { })
      .catch((err) => {
        HandleErrors({
          detail: "Something went wrong. Please try again later.",
        });
      })
      .finally(() => {
        setisExporting(false);
      });
  };

  const AssignType = () => {
    let shiftType = "";
    switch (shifType) {
      case ShiftType.Fixed:
        shiftType = "fixed";
        break;
      case ShiftType.Flexible:
        shiftType = "flexible";
        break;
      case ShiftType.Based:
        shiftType = "based";
        break;
      default:
        break;
    }
    return shiftType;
  };

  return (
    <header className={`my-4 ${styles.container} ${containerStyle}`}>
      <div>
        <Text className={styles.title}>
          {title || t(ShiftTypeName[shifType])}
        </Text>
        <div>
          <Text className={styles.periodText}>Period: </Text>
          <Text className={styles.periodDate}>
            {searchParams.get("startDate") ||
              moment(searchParams.get("startDate") ?? new Date()).format(
                "DD-MM-YYYY"
              )}
          </Text>
          <Text className={styles.periodText}> to </Text>
          {searchParams.get("endDate") ? (
            <Text className={styles.periodDate}>
              {searchParams.get("endDate") ||
                moment(searchParams.get("endDate") || new Date()).format(
                  "DD-MM-YYYY"
                )}
            </Text>
          ) : (
            <Text className={styles.periodDate}>--</Text>
          )}
        </div>
      </div>
      <UploadFiles
        page={`shifts${shifType}`}
        isVisible={isDetailsShown}
        setIsVisible={() => setIsDetailsShown(false)}
      />
      {
        showBtns &&
        (isExporting ? (
          <Spin />
        ) : (
          shiftTypePermission && <div>
            <Button
              isOutline
              btnClassName={styles.headerBtn}
              onClick={() => setIsAssingShown(true)}
            >
              <Text style={{ paddingInline: 5 }}>+</Text>
            </Button>
            <Button
              onClick={() => setIsDetailsShown(true)}
              isOutline
              btnClassName={styles.headerBtn}
            >
              <Image src={DownloadImage} />
            </Button>
            {hasBulkUploadPermission && (
              <Button
                onClick={handleDownloadTemplate}
                isOutline
                btnClassName={styles.headerBtn}
              >
                <Image src={ImportImage} />
              </Button>
            )}
            {showRefreshBtn && canRecalculate && (
              <Tooltip title="Recalculate">
                <span>
                  <Button
                    btnClassName={styles.headerBtn}
                    suffix={<Image src={SYNC_ICON} />}
                    ariaLabel="Recalculate"
                    onClick={() => setIsRecalculateShown(true)}
                  >
                    {" "}
                  </Button>
                </span>
              </Tooltip>
            )}
          </div>
        ))}
      {isRecalculateShown && (
        <Recalculate
          isVisible={isRecalculateShown}
          setIsVisible={setIsRecalculateShown}
        />
      )}
      {isAssignShown && (
        <AssignShift
          isVisible={isAssignShown}
          setIsVisible={() => setIsAssingShown(false)}
          assignType={AssignType()}
          isMultipleAssign
        />
      )}
    </header>
  );
}
